module.exports = __webpack_public_path__ + "static/media/resume.79fc10b2.pdf";